export default "__VITE_ASSET__CjFSVKcU__"